import React, { useContext } from "react";
import { Link,Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
import { TransportOwnerContext } from './TransportOwnerContext';
export default function TransportOwnerAccount(){
    const {transportOwnerData}=useContext(TransportOwnerContext)
    return (
        <div>
           <div className=" flex flex-row max-w-full min-w-fit gap-x-4 mb-4">
            <Link to="change" className=" flex flec-col hover:text-blue-500">
              <FontAwesomeIcon icon={faTachometerAlt} className=" w-12 h-12 hover:text-blue-500"/>account
             </Link>
             <Link to="logout" className=" mb-4">
               <FontAwesomeIcon icon={faSignOut} className=" w-12 h-12 hover:text-blue-500 "/>change
             </Link>            
            </div>
            <div className=" flex flex-col ">
              {transportOwnerData?.profile?<img/>:<FontAwesomeIcon icon={faUser} className=" w-12 h-12 rounded-full"/>}
               <p>Username :{transportOwnerData?.username}</p>
               <p>Useremail :{transportOwnerData?.email}</p>
               <p>name :{transportOwnerData?.name}</p>
              </div>
              
             <Outlet/>
                
        </div>
    )
}